(function () {
  const ALLOWED = new Set(["created-ascending", "best-selling", "price-ascending", "price-descending"]);

  let rafId = null;
  let lastRun = 0;

  function debounceRun() {
    const now = Date.now();
    // evita spam: no máximo 1x a cada 120ms
    if (now - lastRun < 120) return;
    lastRun = now;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => buildSortUI());
  }

  function buildSortUI() {
    const drawer = document.querySelector("#facets-drawer");
    if (!drawer) return;

    // só quando drawer está aberto/visível
    const isOpen = drawer.hasAttribute("open") || drawer.classList.contains("is-open") || drawer.matches(":popover-open");
    // Se o teu drawer não usa estas flags, não faz mal — continua a funcionar pelo click handler.
    // Mas ajuda a reduzir trabalho.
    // if (!isOpen) return;

    const select = drawer.querySelector("select.sort-by-select#SortBy");
    if (!select) return;

    // remove UI antiga (se existir)
    drawer.querySelectorAll(".rh-sort-list").forEach((el) => el.remove());

    const wrapper = document.createElement("div");
    wrapper.className = "rh-sort-list";

    Array.from(select.options).forEach((opt) => {
      if (!ALLOWED.has(opt.value)) return;

      const item = document.createElement("button");
      item.type = "button";
      item.className = "rh-sort-item";
      item.dataset.value = opt.value;

      if (opt.selected) item.classList.add("is-active");

      item.innerHTML = `
        <span class="rh-sort-box" aria-hidden="true"></span>
        <span class="rh-sort-label"></span>
      `;
      item.querySelector(".rh-sort-label").textContent = (opt.textContent || "").trim();

      item.addEventListener("click", () => {
        select.value = opt.value;

        wrapper.querySelectorAll(".rh-sort-item").forEach((b) => b.classList.remove("is-active"));
        item.classList.add("is-active");

        select.dispatchEvent(new Event("change", { bubbles: true }));
      });

      wrapper.appendChild(item);
    });

    // insere UI antes do select e esconde select
    select.parentNode.insertBefore(wrapper, select);
    select.style.display = "none";
  }

  function observeDrawerOnly() {
    const drawer = document.querySelector("#facets-drawer");
    if (!drawer) return;

    // Observa só alterações dentro do drawer (não o body inteiro)
    const obs = new MutationObserver(debounceRun);
    obs.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    debounceRun();
    observeDrawerOnly();
  });

  window.addEventListener("load", debounceRun);

  // quando abres o drawer
  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[aria-controls="facets-drawer"]');
    if (!btn) return;
    debounceRun();
    setTimeout(debounceRun, 150);
    setTimeout(debounceRun, 400);
  });

})();